define('views/content/cd_personals',['require','views/base/list_page_view','views/components/cd_personal/cd_personals','collections/cd_personals','text!templates/content/cd_personals.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var CDPersonalsView = require('views/components/cd_personal/cd_personals');
    var CDPersonalsCollection = require('collections/cd_personals');

    var temp = require("text!templates/content/cd_personals.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'cd-personal-page',
        titleKey: 'personals',

        setCollection: function () {
            this.collection = new CDPersonalsCollection();
        },

        onRender: function() {
            this.ListContainer.show(new CDPersonalsView({
                collection: this.collection
            }));
        }

    });
});
